import React from 'react';

import { Select } from 'antd';
import { hasilTesKategoriOptions } from '../../data/options';

const SelectKategoriHasilTes = ({ ...props }) => {
  return (
    <Select
      {...props}
      placeholder="Pilih kategori"
      style={{
        width: '100%',
      }}
      options={hasilTesKategoriOptions}
    />
  );
};
export default SelectKategoriHasilTes;
